import {Container, Grid, Typography} from '@material-ui/core';
import {WithStyles, withStyles} from '@material-ui/core/styles';
import {WithTranslation, withTranslation} from 'react-i18next';

import {EnumTeamMemberSlideSize} from 'src/Components/Home/Team/TeamMemberBlock/EnumTeamMemberSlideSize';
import {EnumTitlePosition} from 'src/Components/Home/Team/TeamMemberBlock/EnumTitlePosition';
import {teamBlockStyles} from 'src/Components/Home/Team/teamBlockStyles';
import {IAnchorable} from 'src/Routes/Pages/IAnchorable';
import {ITeamMember} from 'src/Routes/Pages/MainPage';
import EnvHelper from 'src/Utils/EnvHelper';

import TeamMemberBlock from './TeamMemberBlock/TeamMemberBlock';

const TeamBlock = (props: ITeamBlockProps) => {
	if (!EnvHelper.shouldShowTeamBlock()) {
		return null;
	}

	return (
		<section className={props.classes.root} id={props.anchor}>
			<Container className={props.classes.container} maxWidth="lg">
				<Grid container spacing={2}>
					<Grid item xs={6} md={6}>
						<Typography variant="h3" className={props.classes.title}>
							{props.t('title')}
						</Typography>
						<Typography variant="h5" className={props.classes.subTitle}>
							{props.t('sub-title')}
						</Typography>
						<Grid justifyContent="flex-end" container>
							<Grid xs={12} item sm={6} md={6} className={props.classes.firstMember}>
								<TeamMemberBlock
									image={props.teamMembers[0].photo}
									title={props.t(`name-${props.teamMembers[0].name}`)}
									jobTitle={props.t(`position-${props.teamMembers[0].position}`)}
									size={EnumTeamMemberSlideSize.LARGE}
								/>
							</Grid>
						</Grid>
					</Grid>
					<Grid item container xs={6} md={6}>
						<Grid spacing={2} container>
							<Grid item xs={12}>
								<TeamMemberBlock
									image={props.teamMembers[1].photo}
									title={props.t(`name-${props.teamMembers[1].name}`)}
									jobTitle={props.t(`position-${props.teamMembers[1].position}`)}
									titlePosition={EnumTitlePosition.IN}
									size={EnumTeamMemberSlideSize.EXTRA_LARGE}
								/>
							</Grid>
						</Grid>
						<Grid spacing={2} container>
							<Grid item xs={7} md={6}>
								<TeamMemberBlock
									image={props.teamMembers[2].photo}
									title={props.t(`name-${props.teamMembers[2].name}`)}
									jobTitle={props.t(`position-${props.teamMembers[2].position}`)}
									size={EnumTeamMemberSlideSize.MEDIUM}
								/>
							</Grid>
							<Grid item xs={5} md={4}>
								<TeamMemberBlock
									image={props.teamMembers[3].photo}
									title={props.t(`name-${props.teamMembers[3].name}`)}
									jobTitle={props.t(`position-${props.teamMembers[3].position}`)}
									size={EnumTeamMemberSlideSize.SMALL}
								/>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Container>
		</section>
	);
};

interface ITeamBlockProps extends IAnchorable, WithStyles, WithTranslation {
	teamMembers: ITeamMember[];
}

export default withStyles(teamBlockStyles)(withTranslation('team')(TeamBlock));
